'use client';

// Event-tab error boundary: a failed tab load (schedule, draw, matches…) replaces only the tab
// content; the event header and tabs from the layouts above stay.
import { startTransition } from 'react';
import { useRouter } from 'next/navigation';
import { ErrorState } from '@/components/ui';
import { useBoundaryErrorReport } from '@/hooks/useBoundaryErrorReport';

export default function EventTabError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();
  useBoundaryErrorReport(error, 'event-tab');

  // reset() alone re-renders the failed server data; refresh fetches it again.
  const retry = () =>
    startTransition(() => {
      router.refresh();
      reset();
    });

  return <ErrorState onRetry={retry} className="my-6" />;
}
